module.exports = __webpack_public_path__ + "img/Table-requirements.673d2e65.svg";